import React from "react";
import { useNavigate } from "react-router-dom";

// Hub de prototipos "ocultos" (no listados en el menú) — solo para ir
// mostrando y probando ideas antes de decidir si pasan a producción.
const DEMOS = [
    {
        titulo: "Crear Patrón (versión simple)",
        descripcion: "Formulario de patrón de rotación pensado para un usuario que viene de Excel: días como botones, secuencia de slots con duración/período, vista previa de calendario en vivo.",
        ruta: "/patrones-rotacion-simple",
        icono: "bi-magic",
    },
    {
        titulo: "Gestión de Slots por Paciente",
        descripcion: "Buscas un paciente, ves cada slot de su patrón y quién lo cubre hoy, y puedes asignar/reasignar el auxiliar desde una fecha en adelante.",
        ruta: "/demo-gestion-slots",
        icono: "bi-people",
    },
];

const Demo = () => {
    const navigate = useNavigate();

    return (
        <div className="container-fluid mt-4 mb-5">
            <div className="alert alert-warning">
                <i className="bi bi-flask me-2"></i>
                <strong>Hub de prototipos.</strong> Esta página no está en el menú — es solo para navegar entre
                las vistas de prueba mientras se van afinando.
            </div>
            <div className="row g-3">
                {DEMOS.map((d) => (
                    <div className="col-md-4" key={d.ruta}>
                        <div className="card h-100 shadow-sm border-0">
                            <div className="card-body d-flex flex-column">
                                <h5 className="fw-bold"><i className={`bi ${d.icono} me-2`}></i>{d.titulo}</h5>
                                <p className="text-muted small flex-grow-1">{d.descripcion}</p>
                                <button className="btn btn-primary" onClick={() => navigate(d.ruta)}>
                                    Abrir <i className="bi bi-arrow-right ms-1"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Demo;
